exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-editor .content blockquote:not(:last-child),.lp-editor .content dl:not(:last-child),.lp-editor .content ol:not(:last-child),.lp-editor .content p:not(:last-child),.lp-editor .content pre:not(:last-child),.lp-editor .content table:not(:last-child),.lp-editor .content ul:not(:last-child){margin-bottom:0!important}.sun-editor-editable p{margin:0!important}", ""]);

// exports
